// Owner, 2026-10-07: Discount/Calculate answers what became of the code it
// was sent — `coupon { code, applied, reasoncode, reason }`. A reason is the
// server's sentence for the customer (today: the menu rule). An older API
// sends no object; then nothing here changes behaviour.
export const readCouponOutcome = (prices) => {
  const c = prices?.coupon;
  if (!c || typeof c !== 'object') return null;
  return {
    code: c.code || '',
    applied: c.applied === true,
    reasoncode: c.reasoncode || null,
    reason: c.reason || null,
  };
};

export const couponRefusedWithReason = (prices) => {
  const o = readCouponOutcome(prices);
  return o && !o.applied && o.reason ? o.reason : null;
};

export const joinOr = (names) =>
  names.length <= 1
    ? names.join('')
    : `${names.slice(0, -1).join(', ')} or ${names[names.length - 1]}`;

export const menuOnlyTag = (coupon) => {
  const names = Array.isArray(coupon?.menunames)
    ? coupon.menunames.filter(Boolean)
    : [];
  if (!names.length) return '';
  return `${joinOr(names)} ${names.length === 1 ? 'menu' : 'menus'} only`;
};
